import { useRef, useState, useEffect } from 'react'
import { ErrorMessage } from 'formik'
import { Skeleton } from '@material-ui/lab'
import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Button,
    Select,
    MenuItem,
    DialogContentText,
    IconButton,
    FormControlLabel,
    Typography,
    Checkbox,
    CircularProgress,
    Avatar,
    Hidden,
} from '@material-ui/core'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { useDispatch, useSelector } from 'react-redux'
import {
    CustomTextField,
    Form,
    SubmitButton,
    Textarea,
} from '../../../utils/formGenerator'
import { Row, Col } from 'react-bootstrap'
import AutoCompleteSearch from '../customSearch/CustomSearch'
import {
    addUserAction,
    deleteUserAction,
    updateAUserProfileAction,
    updateUserAction,
} from '../../../redux/user/userActions'
import {
    createOrderByCustomerAction,
    updateCustomerOrderAction,
    deleteCustomerOrderAction,
} from '../../../redux/customer/customerAction'
import {
    addNewUserSchema,
    addOrderSchema,
    addProductSchema,
    userSchema,
    companySchema,
    replayMessageSchema,
} from '../../../utils/validationsSchema'
import {
    DeleteOutlined,
    RemoveOutlined,
    AttachFileOutlined,
    AttachmentOutlined,
    Send,
} from '@material-ui/icons'
import {
    addNewOrderByAdminAction,
    addNewProcessAction,
    deleteAOrderByAdminAction,
    deleteAProcessAction,
    updateOrderByAdminAction,
    getAOrderByAdminAction,
} from '../../../redux/orders/orderActions'
import { deleteAnnouncementByAdminAction } from '../../../redux/announcement/announcementAction'
import {
    createNewProductByAdminAction,
    updateProductByAdminAction,
    deleteAProductByAdminAction,
} from '../../../redux/product/productActions'
import CustomPicker from '../customDatePicker/CustomDatePicker'
import { values } from 'lodash-es'
import { string } from 'prop-types'
import ProductBuyersList from '../../pages/private/factoryRoutes/factoryOrders/ProductBuyersList'
import { showConversation } from '../jss/showConversation'
import {
    addMessageToTicketAction,
    createNewTicketAction,
} from '../../../redux/tickets/ticketAction'
import { IMAGE_URL } from '../../../config/config'
import { uploadFile } from '../../../services/storage'

const CustomModal = ({
    type,
    size,
    fullWidth,
    show,
    closeModal,
    data,
    scroll,
    route,
    role,
    tableBody,
    customFunction,
    isOutCloseDisable,
}) => {
    let template = null
    const classes = showConversation()

    const modalRef = useRef(null)

    //   -------------- redux states ------------
    const dispatch = useDispatch()
    const { crudLoading, allUsers } = useSelector(state => state.user)
    const { crudLoading: addOrderLoading, customerOrder } = useSelector(
        state => state.customer
    )
    const { deleteLoading } = useSelector(state => state.orders)
    const { userProducts } = useSelector(state => state.product)
    // ---------------------- states ----------------------
    const userRoles = [
        {
            id: 1,
            name: 'مشتری',
            value: 'customer',
        },
        {
            id: 2,
            name: 'مدیر کارخانه',
            value: 'factory_admin',
        },
        {
            id: 3,
            name: 'مدیر سایت',
            value: 'admin',
        },
        {
            id: 4,
            name: 'مدیر تبلیغات',
            value: 'advertising_admin',
        },
    ]
    const userTypes = [
        {
            id: 1,
            name: 'حقوقی',
            value: 'LEGAL',
        },
        {
            id: 2,
            name: 'حقیقی',
            value: 'REAL',
        },
    ]
    const userStatus = [
        {
            id: 1,
            name: 'فعال',
            value: 'ACTIVE',
        },
        {
            id: 2,
            name: 'غیرفعال',
            value: 'INACTIVE',
        },
        {
            id: 3,
            name: 'درحال بررسی',
            value: 'PENDING',
        },
    ]
    const orderStatus = [
        {
            id: 1,
            name: 'درحال بررسی',
            value: 'IN_PROGRESS',
        },
        {
            id: 2,
            name: 'درحال تکمیل',
            value: 'IN_COMPLETING',
        },
        {
            id: 3,
            name: 'تکمیل شده',
            value: 'COMPLETED ',
        },
        {
            id: 4,
            name: 'فعال',
            value: 'ACTIVE ',
        },
    ]
    const productStatus = [
        {
            id: 1,
            name: 'در دسترس',
            value: 'AVAILABLE',
        },
        {
            id: 2,
            name: 'غیرقابل دسترس',
            value: 'UNAVAILABLE',
        },
        {
            id: 3,
            name: 'عدم تولید',
            value: 'LACK_OF_PRODUCTION',
        },
    ]
    const productType = [
        {
            id: 2,
            name: 'VIP',
            value: true,
        },
        {
            id: 3,
            name: 'غیر VIP',
            value: false,
        },
    ]
    // ----------------------------
    if (data && !data?.user_type) {
        data.user_type = 'REAL'
    }
    const [editUser, setEditUser] = useState(data)
    const [addUser, setAddUser] = useState({
        phone_number: '',
        name: '',
        user_type: 'LEGAL',
        national_code: '',
        economic_code: '',
        landline_phone: '',
        address: '',
        postal_code: '',
        representation_code: '',
        status: 'ACTIVE',
        role: '',
    })

    const [addProduct, setAddProduct] = useState({
        name: '',
        code: '',
        status: '',
        is_vip: undefined,
    })

    const [addOrder, setAddOrder] = useState({
        products: [
            {
                product_id: 1,
                number_of_order: 0,
            },
        ],
        description: '',
        has_warranty_card: true,
        // purchaser_id: "",
    })

    const [addProcess, setAddProcess] = useState({
        order_id: data?.id,
        products: [
            {
                product_id: 0,
                number_of_sent: 0,
            },
        ],
        number_of_boxes: 0,
        cargo_location: '',
        cargo_date: null,
        cargo_number: 0,
    })

    const [manualProductValue, setManualProductValue] = useState(101)

    // ------------------------ handleChanges ---------------

    const handleManualProductAmount = () => {
        customFunction(manualProductValue, data.id)
        closeModal()
    }
    const handleChangeEditUser = e =>
        setEditUser(prev => ({
            ...prev,
            [e.target.name]: e.target.value,
        }))

    const handleChangeAddUser = e =>
        setAddUser(prev => ({
            ...prev,
            [e.target.name]: e.target.value,
        }))

    const handleEditCustomerOrder = e =>
        setAddOrder(prev => ({
            ...prev,
            [e.target.name]: e.target.value,
        }))

    const handleChangeAddProcess = e =>
        setAddProcess(prev => ({
            ...prev,
            [e.target.name]: e.target.value,
        }))

    const handleChangeAddProduct = e =>
        setAddProduct(prev => ({
            ...prev,
            [e.target.name]: e.target.value,
        }))

    // ---------- end of handleChanges

    // ----------------------- functions -----------------------

    //   ----------------- useEffects
    useEffect(() => {
        if (route === 'editUser') {
            setEditUser(prev => ({
                ...prev,
                phone_number: data?.phone_number,
                name: data?.name,
                user_type: data?.user_type,
                national_code: data?.national_code,
                economic_code: data?.economic_code,
                landline_phone: data?.landline_phone,
                address: data?.address,
                postal_code: data?.postal_code,
                representation_code: data?.representation_code,
                status: data?.status,
                role: data?.roles[0]?.name,
            }))
        }
        if (route === 'editProduct') {
            setAddProduct(prev => ({
                ...prev,
                name: data?.name,
                code: data?.code,
                status: data?.status,
                is_vip: data?.is_vip,
                // role: data?.roles[0]?.name,
            }))
        }
        if (
            route === 'editCustomerOrder' ||
            route === 'editCustomerOrderAdmin'
        ) {
            setAddOrder(prev => {
                const products =
                    role === 'admin'
                        ? data?.order_item
                        : customerOrder?.order_item
                const body = role === 'admin' ? data : customerOrder
                return {
                    ...prev,
                    ...body,
                    products,
                }
            })
        }
    }, [data, route, customerOrder, role])

    //   ------------------- submitForms
    const handleEditUser = values => {
        const copyState = { ...values }
        delete copyState.roles
        dispatch(updateUserAction(data?.id, copyState, closeModal))
    }

    const checkCodeMeli = code => {
        var L = code.length

        if (L < 8 || parseInt(code, 10) == 0) return false
        code = ('0000' + code).substr(L + 4 - 10)
        if (parseInt(code.substr(3, 6), 10) == 0) return false
        var c = parseInt(code.substr(9, 1), 10)
        var s = 0
        for (var i = 0; i < 9; i++)
            s += parseInt(code.substr(i, 1), 10) * (10 - i)
        s = s % 11
        return (s < 2 && c == s) || (s >= 2 && c == 11 - s)
        return true
    }

    const handleEditUserProfile = values => {
        const copyState = { ...values }
        delete copyState.roles
        if (checkCodeMeli(copyState?.national_code)) {
            dispatch(updateAUserProfileAction(copyState, closeModal))
        } else {
            alert('کد ملی صحیح نمیباشد')
        }
    }

    const handleAddUser = values => {
        dispatch(addUserAction(values, closeModal))
    }

    const handleEditOrder = async values => {
        // if(!values.product[values.product.length])
        values.products.map(item => {
            if (!item.number_of_delivery) item.number_of_delivery = 0
            if (!item.number_of_left) item.number_of_left = 0
            if (!item.number_of_order) item.number_of_order = 0
            if (!item.number_of_sent) item.number_of_sent = 0
        })
        if (role === 'admin') {
            await dispatch(updateOrderByAdminAction(data?.id, values)).then(
                () => {
                    dispatch(getAOrderByAdminAction(data?.id))
                    closeModal()
                }
            )
        } else {
            dispatch(
                await updateCustomerOrderAction(
                    customerOrder?.id,
                    values,
                    closeModal
                )
            )
        }
    }

    const handleAddOrder = values => {
        if (role === 'admin') {
            dispatch(addNewOrderByAdminAction(values, tableBody, closeModal))
        } else {
            dispatch(createOrderByCustomerAction(values, closeModal))
        }
    }

    const handleAddNewProcess = values => {
        const copyValues = { ...values }
        copyValues.cargo_number = +copyValues.cargo_number
        copyValues.number_of_boxes = +copyValues.number_of_boxes
        dispatch(addNewProcessAction(copyValues, closeModal))
    }

    const handleAddNewProduct = values => {
        dispatch(createNewProductByAdminAction(values, tableBody, closeModal))
    }

    const handleEditProduct = values => {
        dispatch(updateProductByAdminAction(data?.id, values, closeModal))
    }

    // ---------------------------- end submit forms

    // -------------------- orders
    const handleChangeOrderProducts = (i, e) => {
        let products = [...addOrder.products]
        products[i] = { ...products[i], [e.target.name]: +e.target.value }
        setAddOrder({
            ...addOrder,
            products,
        })
    }
    const addMoreOrderProduct = () => {
        const product = [...addOrder.products]
        product.push({
            product_id: 0,
            number_of_order: 0,
        })
        setAddOrder({
            ...addOrder,
            products: product,
        })
    }

    const removeProductItem = i => {
        let products = [...addOrder.products]
        products.splice(i, 1)
        setAddOrder({
            ...addOrder,
            products,
        })
    }

    const createAddNewProduct = () => {
        return addOrder?.products?.map((el, i) => (
            <Row key={i} className="d-flex align-items-start">
                <Col md={4} xs={12}>
                    <AutoCompleteSearch
                        id={`selectProduct${i}`}
                        multiple={false}
                        data={userProducts}
                        value={el?.product || ''}
                        handleChangeAuto={(e, values) =>
                            setAddOrder(prev => {
                                let products = [...addOrder.products]
                                products[i] = {
                                    ...products[i],
                                    product_id: values?.id,
                                    product: values,
                                }
                                return { ...prev, products }
                            })
                        }
                        label="انتخاب محصول"
                        placeHolder="انتخاب محصول"
                        name="product_id"
                    />
                </Col>
                <Col lg={2} md={3} sm={8} xs={8} className="mt-xs-5">
                    <CustomTextField
                        name="number_of_order"
                        placeholder="تعداد سفارش"
                        value={el.number_of_order || '0'}
                        onChange={e => handleChangeOrderProducts(i, e)}
                        label="سفارش"
                        wrapperClass="my-0 d-flex align-items-center"
                        labelClass="mx-3"
                    />
                </Col>
                <Col md={1} sm={1} xs={1}>
                    <IconButton onClick={() => removeProductItem(i)}>
                        <RemoveOutlined color="error" />
                    </IconButton>
                </Col>
            </Row>
        ))
    }
    // ----------------------end orders

    // ----------process -------------
    const handleChangeProcessProducts = (i, e) => {
        let products = [...addProcess.products]
        products[i] = { ...products[i], [e.target.name]: +e.target.value }
        setAddProcess({
            ...addProcess,
            products,
        })
    }
    const addMoreProcessProduct = () => {
        const product = [...addProcess.products]
        product.push({
            product_id: 0,
            number_of_order: 0,
        })
        setAddProcess({
            ...addProcess,
            products: product,
        })
    }
    const removeProcessProductItem = i => {
        let products = [...addProcess.products]
        products.splice(i, 1)
        setAddProcess({
            ...addProcess,
            products,
        })
    }
    const createAddNewProcess = () => {
        return addProcess.products.map((el, i) => (
            <Row key={i} className="my-3">
                <Col md={5} xs={12}>
                    <AutoCompleteSearch
                        id={`selectProduct${i}`}
                        multiple={false}
                        data={userProducts}
                        value={el?.product || ''}
                        disabled
                        handleChangeAuto={(e, values) =>
                            setAddProcess(prev => {
                                let products = [...addProcess.products]
                                products[i] = {
                                    ...products[i],
                                    product_id: values?.id,
                                    product: values,
                                }
                                return { ...prev, products }
                            })
                        }
                        label="انتخاب محصول"
                        placeHolder="انتخاب محصول"
                        name="product_id"
                    />
                </Col>
                <Col md={5} xs={8}>
                    <CustomTextField
                        name="number_of_sent"
                        placeholder="تعداد ارسالی"
                        value={el.number_of_sent || ''}
                        onChange={e => handleChangeProcessProducts(i, e)}
                        label="تعداد ارسالی"
                        disabled
                        wrapperClass="my-0 d-flex align-items-center"
                        labelClass="mx-3"
                    />
                </Col>
                <Col md={2} xs={2}>
                    <IconButton onClick={() => removeProcessProductItem(i)}>
                        <RemoveOutlined color="error" />
                    </IconButton>
                </Col>
            </Row>
        ))
    }
    const resetState = () => {
        inputFileRef.current.value = ''
        setSendMessage(() => ({
            text: '',
            status: 'OPEN',
            url: '',
            fileName: null,
            file: null,
        }))
    }

    const [sendMessage, setSendMessage] = useState({
        text: '',
        status: 'OPEN',
        url: '',
        fileName: null,
        file: null,
        section: '',
        title: '',
    })
    const submitMessage = async values => {
        let copyState = { ...sendMessage }
        if (copyState?.fileName) {
            let formData = new FormData()
            formData.append('file', copyState?.file)

            const { data: responseData } = await uploadFile(formData)
            if (responseData?.data && responseData?.code === 200) {
                copyState.url = responseData?.data
            }
        }
        if (copyState?.url === '') {
            delete copyState?.url
        }
        if (type === 'createConversation') {
            dispatch(createNewTicketAction(copyState, resetState, closeModal))
        } else if (type === 'showConversation') {
            dispatch(addMessageToTicketAction(data?.id, copyState, resetState))
        }
    }
    const sectionTypes = [
        {
            id: 1,
            name: 'فنی',
            value: 'TECHNICAL',
        },
        {
            id: 2,
            name: 'مالی',
            value: 'FINANCIAL',
        },
    ]
    const inputFileRef = useRef(null)
    const textRef = useRef(null)
    const onChangeHandler = e => {
        const target = e.target
        textRef.current.style.height = '35px'
        textRef.current.style.height = `${target.scrollHeight}px`
        setSendMessage(prev => ({
            ...prev,
            [target.name]: target.value,
        }))
    }
    switch (type) {
        case 'showConversation':
            template = (
                <>
                    <DialogTitle id="max-width-dialog-title">
                        مشاهده گفتگوها {data?.title}
                    </DialogTitle>
                    <DialogContent className={classes.root}>
                        {data?.conversation?.map((message, index) => (
                            <div key={index} className={classes.message}>
                                {!message?.is_admin_response && (
                                    <Avatar className="avatar">
                                        {data?.user?.name}
                                    </Avatar>
                                )}
                                <div
                                    className={`mainWrapper ${
                                        message?.is_admin_response
                                            ? 'admin'
                                            : 'user'
                                    }`}
                                >
                                    <div className="top mb-5">
                                        <Typography component="p">
                                            <Hidden smDown>
                                                ارسال شده در تاریخ:
                                            </Hidden>
                                            {new Date(
                                                message?.time
                                            ).toLocaleString('fa-IR')}
                                        </Typography>
                                        <div>
                                            {message?.url &&
                                            message?.url !== '' ? (
                                                <a
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    href={`${IMAGE_URL}${message?.url}`}
                                                    download
                                                    // onClick={e =>
                                                    //     downloadLink(
                                                    //         e,
                                                    //         'ticket'
                                                    //     )
                                                    // }
                                                >
                                                    <IconButton size="small">
                                                        <AttachFileOutlined />
                                                    </IconButton>
                                                </a>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div>
                                        <Typography component="p">
                                            {message?.text}
                                        </Typography>
                                    </div>
                                </div>
                                {message?.is_admin_response && (
                                    <Avatar
                                        className={`${
                                            message?.is_admin_response
                                                ? 'adminAvatar'
                                                : ''
                                        } avatar`}
                                    >
                                        {/* {message?.user} */}
                                        ادمین
                                    </Avatar>
                                )}
                            </div>
                        ))}
                        {crudLoading && (
                            <Typography
                                className="my-2 p-2"
                                component="div"
                                variant={'h1'}
                            >
                                <Skeleton />
                            </Typography>
                        )}
                        <Form
                            enableReinitialize
                            initialValues={sendMessage}
                            validationSchema={replayMessageSchema}
                            onSubmit={submitMessage}
                        >
                            <div className={classes.chooseFile}>
                                <input
                                    name="url"
                                    type="file"
                                    id="ticketAttachment"
                                    ref={inputFileRef}
                                    onChange={event =>
                                        setSendMessage(prev => ({
                                            ...prev,
                                            fileName:
                                                event.target.files[0]?.name,
                                            file: event.target.files[0],
                                        }))
                                    }
                                    hidden
                                    accept="image/png, image/jpeg"
                                />
                                <label
                                    htmlFor="ticketAttachment"
                                    className="my-3"
                                >
                                    <span className="bg-success rounded py-2 px-3 text-white pointer mr-2">
                                        <AttachmentOutlined className="mr-2" />
                                        انتخاب فایل
                                    </span>
                                    {sendMessage?.fileName !== null
                                        ? sendMessage?.fileName
                                        : '  '}
                                </label>
                            </div>
                            <div className={classes.sendMessage}>
                                <label htmlFor="message">ارسال پاسخ: </label>
                                <textarea
                                    id="message"
                                    name="text"
                                    className={`${classes.textarea} message`}
                                    value={sendMessage.text}
                                    ref={textRef}
                                    onChange={onChangeHandler}
                                />
                                <IconButton
                                    size="small"
                                    className={`sendIcon`}
                                    disabled={sendMessage?.text === ''}
                                    type="submit"
                                    color={
                                        sendMessage?.text === ''
                                            ? 'disabled'
                                            : 'primary'
                                    }
                                >
                                    <Send
                                        color={
                                            sendMessage?.text === ''
                                                ? 'disabled'
                                                : 'primary'
                                        }
                                    />
                                </IconButton>
                            </div>
                            <ErrorMessage
                                name={'text'}
                                render={msg => (
                                    <div style={{ color: 'orangered' }}>
                                        {msg}
                                    </div>
                                )}
                            />
                        </Form>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="contained"
                            className="bg-danger text-white"
                            onClick={() => closeModal()}
                        >
                            بازگشت
                        </Button>
                    </DialogActions>
                </>
            )
            break
        case 'createConversation':
            template = (
                <>
                    <DialogTitle id="max-width-dialog-title">
                        ایجاد تیکت
                    </DialogTitle>
                    <DialogContent className={classes.root}>
                        {crudLoading && (
                            <Typography
                                className="my-2 p-2"
                                component="div"
                                variant={'h1'}
                            >
                                <Skeleton />
                            </Typography>
                        )}
                        <Form
                            enableReinitialize
                            initialValues={sendMessage}
                            validationSchema={replayMessageSchema}
                            onSubmit={submitMessage}
                        >
                            <div className={classes.sendMessage}>
                                <label htmlFor="message">عنوان پیام: </label>
                                <textarea
                                    id="message"
                                    name="title"
                                    className={`${classes.textarea} message`}
                                    value={sendMessage.title}
                                    ref={textRef}
                                    onChange={onChangeHandler}
                                />
                            </div>
                            {/* <div className={classes.sendMessage}>
                                <label htmlFor="message">موضوع: </label>
                                <Select
                                    name="section"
                                    style={{ width: '100%' }}
                                    labelId="demo-simple-select-label-user_type"
                                    id="demo-simple-select-user_type"
                                    onChange={onChangeHandler}
                                >
                                    {sectionTypes.map(item => (
                                        <MenuItem
                                            key={item?.id}
                                            value={item.value}
                                        >
                                            {item?.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </div> */}
                            <div className={classes.chooseFile}>
                                <input
                                    name="url"
                                    type="file"
                                    id="ticketAttachment"
                                    ref={inputFileRef}
                                    onChange={event =>
                                        setSendMessage(prev => ({
                                            ...prev,
                                            fileName:
                                                event.target.files[0]?.name,
                                            file: event.target.files[0],
                                        }))
                                    }
                                    hidden
                                    accept="image/png, image/jpeg"
                                />
                                <label
                                    htmlFor="ticketAttachment"
                                    className="my-3"
                                >
                                    <span className="bg-success rounded py-2 px-3 text-white pointer mr-2">
                                        <AttachmentOutlined className="mr-2" />
                                        انتخاب فایل
                                    </span>
                                    {sendMessage?.fileName !== null
                                        ? sendMessage?.fileName
                                        : '  '}
                                </label>
                            </div>

                            <div className={classes.sendMessage}>
                                <label htmlFor="message">متن پیام: </label>
                                <textarea
                                    id="message"
                                    name="text"
                                    className={`${classes.textarea} message`}
                                    value={sendMessage?.text}
                                    ref={textRef}
                                    onChange={onChangeHandler}
                                />
                                <IconButton
                                    size="small"
                                    className={`sendIcon`}
                                    disabled={
                                        sendMessage?.text === '' ||
                                        // sendMessage?.section === '' ||
                                        sendMessage?.title === ''
                                    }
                                    type="submit"
                                    color={
                                        sendMessage?.text === '' ||
                                        // sendMessage?.section === '' ||
                                        sendMessage?.title === ''
                                            ? 'disabled'
                                            : 'primary'
                                    }
                                >
                                    <Send
                                        color={
                                            sendMessage?.text === '' ||
                                            // sendMessage?.section === '' ||
                                            sendMessage?.title === ''
                                                ? 'disabled'
                                                : 'primary'
                                        }
                                    />
                                </IconButton>
                            </div>
                            <ErrorMessage
                                name={'text'}
                                render={msg => (
                                    <div style={{ color: 'orangered' }}>
                                        {msg}
                                    </div>
                                )}
                            />
                        </Form>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="contained"
                            className="bg-danger text-white"
                            onClick={() => closeModal()}
                        >
                            بازگشت
                        </Button>
                    </DialogActions>
                </>
            )
            break
        case 'completeUserInfoAlert':
            template = (
                <>
                    <Form
                        enableReinitialize
                        initialValues={editUser}
                        onSubmit={
                            role === 'customer'
                                ? handleEditUserProfile
                                : handleEditUser
                        }
                        validationSchema={
                            role === 'customer'
                                ? editUser?.user_type === 'REAL'
                                    ? userSchema
                                    : companySchema
                                : addNewUserSchema
                        }
                    >
                        <DialogTitle
                            id="max-width-dialog-title"
                            className="d-flex align-items-center justify-content-between w-100"
                        >
                            <div
                                className="text-muted "
                                style={{ fontSize: '16px' }}
                            >
                                {data?.status === 'PENDING' &&
                                    'حساب کاربری شما در حال بررسی می باشد. لطفا از بخش تنظیمات کاربری اطلاعات حساب را تکمیل بفرمایید'}
                            </div>
                        </DialogTitle>

                        <DialogActions>
                            <Button
                                variant="contained"
                                onClick={() => closeModal()}
                            >
                                بازگشت
                            </Button>
                        </DialogActions>
                    </Form>
                </>
            )
            break
        case 'announcementGuide':
            template = (
                <>
                    <Form>
                        <DialogTitle
                            id="max-width-dialog-title"
                            className="d-flex align-items-center justify-content-between w-100"
                        >
                            <div
                                className="text-muted "
                                style={{ fontSize: '16px' }}
                            >
                                از این قسمت می توانید اعلانات جدید مربوط به
                                محصولات را دریافت کنید
                            </div>
                        </DialogTitle>

                        <DialogActions>
                            <Button
                                variant="contained"
                                onClick={() => closeModal()}
                            >
                                بازگشت
                            </Button>
                        </DialogActions>
                    </Form>
                </>
            )
            break
        case 'supportGuide':
            template = (
                <>
                    <Form>
                        <DialogTitle
                            id="max-width-dialog-title"
                            className="d-flex align-items-center justify-content-between w-100"
                        >
                            <div
                                className="text-muted "
                                style={{ fontSize: '16px' }}
                            >
                                از این قسمت می توانید جهت پشتیانی با فروش پیام
                                ارسال کنید
                            </div>
                        </DialogTitle>

                        <DialogActions>
                            <Button
                                variant="contained"
                                onClick={() => closeModal()}
                            >
                                بازگشت
                            </Button>
                        </DialogActions>
                    </Form>
                </>
            )
            break
        case 'editUser':
            template = (
                <>
                    <Form
                        enableReinitialize
                        initialValues={editUser}
                        onSubmit={
                            role === 'customer'
                                ? handleEditUserProfile
                                : handleEditUser
                        }
                        validationSchema={
                            role === 'customer'
                                ? editUser?.user_type === 'REAL'
                                    ? userSchema
                                    : companySchema
                                : addNewUserSchema
                        }
                    >
                        <DialogTitle
                            id="max-width-dialog-title"
                            className="d-flex align-items-center justify-content-between w-100"
                        >
                            <div>ویرایش کاربر {data?.name}</div>
                            <div
                                className="text-muted "
                                style={{ fontSize: '12px' }}
                            >
                                {(data?.status === 'PENDING' ||
                                    data?.status === 'INACTIVE') &&
                                    'حساب کاربری شما غیرفعال می باشد'}
                            </div>
                        </DialogTitle>
                        <DialogContent>
                            <div className="text-center">
                                <Row className="mb-6">
                                    <Col md={4} sm={6}>
                                        <Typography
                                            className="my-3"
                                            component="p"
                                        >
                                            نوع کاربری:
                                        </Typography>
                                        <Select
                                            style={{ width: '100%' }}
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            name="user_type"
                                            value={editUser?.user_type}
                                            onChange={e =>
                                                setEditUser(prev => ({
                                                    ...prev,
                                                    user_type: e.target.value,
                                                }))
                                            }
                                        >
                                            {userTypes.map(item => (
                                                <MenuItem
                                                    key={item?.id}
                                                    value={item?.value}
                                                >
                                                    {item?.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Col>
                                    {role !== 'customer' && (
                                        <>
                                            <Col md={4} sm={6}>
                                                <Typography
                                                    className="my-3"
                                                    component="p"
                                                >
                                                    وضعیت کاربر:
                                                </Typography>
                                                <Select
                                                    style={{ width: '100%' }}
                                                    labelId="demo-simple-select-label-user_type"
                                                    id="demo-simple-select-user_type"
                                                    value={editUser?.status}
                                                    onChange={e =>
                                                        setEditUser(prev => ({
                                                            ...prev,
                                                            status:
                                                                e.target.value,
                                                        }))
                                                    }
                                                >
                                                    {userStatus.map(item => (
                                                        <MenuItem
                                                            key={item?.id}
                                                            value={item?.value}
                                                        >
                                                            {item?.name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </Col>
                                            <Col md={4} sm={6}>
                                                <Typography
                                                    className="my-3"
                                                    component="p"
                                                >
                                                    وظیفه کاربر:
                                                </Typography>
                                                <Select
                                                    style={{ width: '100%' }}
                                                    labelId="demo-simple-select-label-user_type"
                                                    id="demo-simple-select-user_type"
                                                    value={editUser?.role}
                                                    onChange={e =>
                                                        setEditUser(prev => ({
                                                            ...prev,
                                                            role:
                                                                e.target.value,
                                                        }))
                                                    }
                                                >
                                                    {userRoles.map(item => (
                                                        <MenuItem
                                                            key={item?.id}
                                                            value={item?.value}
                                                        >
                                                            {item?.name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </Col>
                                        </>
                                    )}
                                </Row>
                                <Row className="mt-3">
                                    <Col md={4}>
                                        <CustomTextField
                                            label="شماره همراه"
                                            name="phone_number"
                                            value={editUser.phone_number}
                                            handleChange={handleChangeEditUser}
                                            margin="normal"
                                        />
                                    </Col>
                                    <Col md={8}>
                                        <CustomTextField
                                            label={
                                                editUser?.user_type === 'REAL'
                                                    ? 'نام و نام خانوادگی'
                                                    : 'نام شرکت'
                                            }
                                            name="name"
                                            value={editUser.name}
                                            handleChange={handleChangeEditUser}
                                            margin="normal"
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col md={4}>
                                        <CustomTextField
                                            label={
                                                editUser?.user_type === 'REAL'
                                                    ? 'کد ملی'
                                                    : 'شماره اقتصادی'
                                            }
                                            name={
                                                editUser?.user_type === 'REAL'
                                                    ? 'national_code'
                                                    : 'economic_code'
                                            }
                                            value={
                                                editUser?.user_type === 'REAL'
                                                    ? editUser?.national_code
                                                    : editUser?.economic_code
                                            }
                                            handleChange={handleChangeEditUser}
                                            margin="normal"
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <CustomTextField
                                            label="کد نمایندگی"
                                            name="representation_code"
                                            value={editUser.representation_code}
                                            handleChange={handleChangeEditUser}
                                            margin="normal"
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <CustomTextField
                                            label="شماره تلفن ثابت"
                                            name="landline_phone"
                                            value={editUser?.landline_phone}
                                            handleChange={handleChangeEditUser}
                                            margin="normal"
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col md={8}>
                                        <CustomTextField
                                            label="آدرس"
                                            name="address"
                                            value={editUser?.address}
                                            handleChange={handleChangeEditUser}
                                            margin="normal"
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <CustomTextField
                                            label="کد پستی"
                                            name="postal_code"
                                            value={editUser.postal_code}
                                            handleChange={handleChangeEditUser}
                                            margin="normal"
                                        />
                                    </Col>
                                </Row>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <SubmitButton
                                title="ویرایش"
                                className="btn-bg-gold mx-2"
                                type="submit"
                                variant="contained"
                                loading={crudLoading}
                            />
                            <Button
                                variant="contained"
                                onClick={() => closeModal()}
                            >
                                بازگشت
                            </Button>
                        </DialogActions>
                    </Form>
                </>
            )
            break

        //   ----------------- addUser
        case 'addUser':
            template = (
                <>
                    <Form
                        enableReinitialize
                        initialValues={addUser}
                        onSubmit={handleAddUser}
                        validationSchema={addNewUserSchema}
                    >
                        <DialogTitle id="max-width-dialog-title">
                            ایجاد کاربر
                        </DialogTitle>
                        <DialogContent>
                            <Row className="mb-6">
                                <Col md={4} sm={6}>
                                    <Typography className="my-3" component="p">
                                        نوع کاربری:
                                    </Typography>
                                    <Select
                                        style={{ width: '100%' }}
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={addUser?.user_type}
                                        onChange={e =>
                                            setAddUser(prev => ({
                                                ...prev,
                                                user_type: e.target.value,
                                            }))
                                        }
                                    >
                                        {userTypes.map(item => (
                                            <MenuItem
                                                key={item?.id}
                                                value={item?.value}
                                            >
                                                {item?.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Col>
                                <Col md={4} sm={6}>
                                    <Typography className="my-3" component="p">
                                        وضعیت کاربر:
                                    </Typography>
                                    <Select
                                        style={{ width: '100%' }}
                                        labelId="demo-simple-select-label-user_type"
                                        id="demo-simple-select-user_type"
                                        value={addUser?.status}
                                        onChange={e =>
                                            setAddUser(prev => ({
                                                ...prev,
                                                status: e.target.value,
                                            }))
                                        }
                                    >
                                        {userStatus.map(item => (
                                            <MenuItem
                                                key={item?.id}
                                                value={item?.value}
                                            >
                                                {item?.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Col>
                                <Col md={4} sm={6}>
                                    <Typography className="my-3" component="p">
                                        وظیفه کاربر:
                                    </Typography>
                                    <Select
                                        style={{ width: '100%' }}
                                        labelId="demo-simple-select-label-user_type"
                                        id="demo-simple-select-user_type"
                                        value={addUser?.role}
                                        onChange={e =>
                                            setAddUser(prev => ({
                                                ...prev,
                                                role: e.target.value,
                                            }))
                                        }
                                    >
                                        {userRoles.map(item => (
                                            <MenuItem
                                                key={item?.id}
                                                value={item?.value}
                                            >
                                                {item?.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Col>
                            </Row>
                            {/* <Divider variant="fullWidth" className="text-center my-5" /> */}
                            <Row className="mt-3">
                                <Col md={4}>
                                    <CustomTextField
                                        label="شماره همراه"
                                        name="phone_number"
                                        value={addUser.phone_number}
                                        handleChange={handleChangeAddUser}
                                        margin="normal"
                                    />
                                </Col>
                                <Col md={8}>
                                    <CustomTextField
                                        label={
                                            addUser?.user_type === 'REAL'
                                                ? 'نام و نام خانوادگی'
                                                : 'نام شرکت'
                                        }
                                        name="name"
                                        value={addUser.name}
                                        handleChange={handleChangeAddUser}
                                        margin="normal"
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col md={4}>
                                    <CustomTextField
                                        label={
                                            addUser?.user_type === 'REAL'
                                                ? 'کد ملی'
                                                : 'شماره اقتصادی'
                                        }
                                        name={
                                            addUser?.user_type === 'REAL'
                                                ? 'national_code'
                                                : 'economic_code'
                                        }
                                        value={
                                            addUser?.user_type === 'REAL'
                                                ? addUser.national_code
                                                : addUser.economic_code
                                        }
                                        handleChange={handleChangeAddUser}
                                        margin="normal"
                                    />
                                </Col>
                                <Col md={4}>
                                    <CustomTextField
                                        label="کد نمایندگی"
                                        name="representation_code"
                                        value={addUser.representation_code}
                                        handleChange={handleChangeAddUser}
                                        margin="normal"
                                    />
                                </Col>
                                <Col md={4}>
                                    <CustomTextField
                                        label="شماره تلفن ثابت"
                                        name="landline_phone"
                                        value={addUser.landline_phone}
                                        handleChange={handleChangeAddUser}
                                        margin="normal"
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col md={8}>
                                    <CustomTextField
                                        label="آدرس"
                                        name="address"
                                        value={addUser.address}
                                        handleChange={handleChangeAddUser}
                                        margin="normal"
                                    />
                                </Col>
                                <Col md={4}>
                                    <CustomTextField
                                        label="کد پستی"
                                        name="postal_code"
                                        value={addUser.postal_code}
                                        handleChange={handleChangeAddUser}
                                        margin="normal"
                                    />
                                </Col>
                            </Row>
                        </DialogContent>
                        <DialogActions>
                            <SubmitButton
                                variant="contained"
                                className="btn-bg-gold mx-2"
                                type="submit"
                                loading={crudLoading}
                                title="ایجاد"
                            />
                            <Button
                                variant="contained"
                                onClick={() => closeModal()}
                            >
                                بازگشت
                            </Button>
                        </DialogActions>
                    </Form>
                </>
            )
            break
        case 'deleteUser':
            template = (
                <>
                    <DialogTitle id="max-width-dialog-title">
                        حذف کاربر {data?.name}
                    </DialogTitle>
                    <DialogContent>
                        <div className="text-center">
                            <DeleteOutlined className="text-danger" />
                        </div>
                        <DialogContentText>
                            آیا از حذف این کاربر اطمینان دارید؟
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <SubmitButton
                            variant="contained"
                            className="bg-danger text-white mx-2"
                            onClick={() =>
                                dispatch(deleteUserAction(data?.id, closeModal))
                            }
                            loading={crudLoading}
                            title="حذف"
                        />
                        <Button
                            variant="contained"
                            onClick={() => closeModal()}
                        >
                            بازگشت
                        </Button>
                    </DialogActions>
                </>
            )
            break
        case 'addCustomerOrder':
        case 'editCustomerOrder':
            template = (
                <>
                    <Form
                        enableReinitialize
                        initialValues={addOrder}
                        onSubmit={
                            type === 'editCustomerOrder'
                                ? handleEditOrder
                                : handleAddOrder
                        }
                        validationSchema={addOrderSchema}
                    >
                        <DialogTitle id="max-width-dialog-title">
                            {type === 'editCustomerOrder'
                                ? 'ویرایش سفارش'
                                : 'ایجاد سفارش'}
                        </DialogTitle>
                        <DialogContent>
                            {role === 'admin' && (
                                <Row className="my-3 d-flex align-items-end justify-content-between ">
                                    <Col md={6}>
                                        <AutoCompleteSearch
                                            id="selectAUser"
                                            multiple={false}
                                            data={allUsers}
                                            value={addOrder?.purchaser || ''}
                                            handleChangeAuto={(e, values) =>
                                                setAddOrder(prev => ({
                                                    ...prev,
                                                    purchaser_id: values?.id,
                                                    purchaser: values,
                                                }))
                                            }
                                            label="انتخاب کاربر"
                                            placeHolder="انتخاب کاربر"
                                            name="purchaser_id"
                                        />
                                    </Col>
                                    {type === 'editCustomerOrder' && (
                                        <Col md={6}>
                                            <Typography
                                                className="my-3"
                                                component="p"
                                            >
                                                وضعیت سفارش:
                                            </Typography>
                                            <Select
                                                style={{ width: '100%' }}
                                                labelId="demo-simple-select-label-user_type"
                                                id="demo-simple-select-user_type"
                                                value={addOrder?.status}
                                                onChange={e =>
                                                    setAddOrder(prev => ({
                                                        ...prev,
                                                        status: e.target.value,
                                                    }))
                                                }
                                            >
                                                {orderStatus.map(item => (
                                                    <MenuItem
                                                        key={item?.id}
                                                        value={item?.value}
                                                    >
                                                        {item?.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Col>
                                    )}
                                </Row>
                            )}
                            <Row className="my-3">
                                <Col>
                                    <Textarea
                                        placeholder="توضیحات محصول را وارد نمایید"
                                        label="توضیحات محصول"
                                        name="description"
                                        defaultValue={addOrder.description}
                                        handleChange={handleEditCustomerOrder}
                                        margin="normal"
                                    />
                                </Col>
                            </Row>
                            <Row className="my-1">
                                <Col>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={
                                                    addOrder.has_warranty_card
                                                }
                                                onChange={e =>
                                                    setAddOrder(prev => ({
                                                        ...prev,
                                                        has_warranty_card:
                                                            e.target.checked,
                                                    }))
                                                }
                                                name="has_warranty_card"
                                                color="primary"
                                            />
                                        }
                                        label="گارانتی"
                                    />
                                </Col>
                            </Row>
                            {createAddNewProduct()}
                            <Row className="my-3">
                                <Col className="text-center">
                                    <Button
                                        className="btn-bg-gold"
                                        onClick={addMoreOrderProduct}
                                    >
                                        ردیف جدید
                                    </Button>
                                </Col>
                            </Row>
                        </DialogContent>
                        <DialogActions>
                            <SubmitButton
                                variant="contained"
                                className="btn-bg-gold mx-2"
                                type="submit"
                                // loading={addOrderLoading}
                                title={
                                    type === 'editCustomerOrder'
                                        ? 'ویرایش'
                                        : type === 'editCustomOrderAdmin'
                                        ? 'ویرایش'
                                        : 'ایجاد'
                                }
                            />
                            <Button
                                variant="contained"
                                onClick={() => closeModal()}
                            >
                                بازگشت
                            </Button>
                        </DialogActions>
                    </Form>
                </>
            )
            break
        case 'editCustomerOrderAdmin':
            template = (
                <>
                    <Form
                        enableReinitialize
                        initialValues={addOrder}
                        onSubmit={handleEditOrder}
                        validationSchema={addOrderSchema}
                    >
                        <DialogTitle id="max-width-dialog-title">
                            ویرایش سفارش
                        </DialogTitle>
                        <DialogContent>
                            {createAddNewProduct()}
                            <Row className="my-3">
                                <Col className="text-center">
                                    <Button
                                        className="btn-bg-gold"
                                        onClick={addMoreOrderProduct}
                                    >
                                        ردیف جدید
                                    </Button>
                                </Col>
                            </Row>
                        </DialogContent>
                        <DialogActions>
                            <SubmitButton
                                variant="contained"
                                className="btn-bg-gold mx-2"
                                type="submit"
                                loading={addOrderLoading}
                                title={'ویرایش'}
                            />
                            <Button
                                variant="contained"
                                onClick={() => closeModal()}
                            >
                                بازگشت
                            </Button>
                        </DialogActions>
                    </Form>
                </>
            )
            break
        case 'deleteCustomerOrder':
            template = (
                <>
                    <DialogTitle id="max-width-dialog-title">
                        حذف سفارش
                    </DialogTitle>
                    <DialogContent>
                        <div className="text-center">
                            <DeleteOutlined className="text-danger" />
                        </div>
                        <DialogContentText>
                            آیا از حذف این سفارش اطمینان دارید؟
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <SubmitButton
                            variant="contained"
                            className="bg-danger text-white mx-2"
                            onClick={() =>
                                dispatch(
                                    deleteCustomerOrderAction(
                                        data?.id,
                                        closeModal
                                    )
                                )
                            }
                            loading={crudLoading}
                            title="حذف"
                        />
                        <Button
                            variant="contained"
                            onClick={() => closeModal()}
                        >
                            بازگشت
                        </Button>
                    </DialogActions>
                </>
            )
            break
        case 'addNewProcess':
            template = (
                <>
                    <Form
                        enableReinitialize
                        initialValues={addProcess}
                        onSubmit={handleAddNewProcess}
                        validationSchema={addProductSchema}
                    >
                        <DialogTitle id="max-width-dialog-title">
                            ایجاد پردازش
                        </DialogTitle>
                        <DialogContent>
                            <Row className="my-3">
                                <Col md={6}>
                                    <CustomTextField
                                        label="تعداد جعبه"
                                        name="number_of_boxes"
                                        value={addProcess.number_of_boxes}
                                        handleChange={handleChangeAddProcess}
                                        margin="normal"
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomTextField
                                        label="شماره بارنامه"
                                        name="cargo_number"
                                        value={addProcess.cargo_number}
                                        handleChange={handleChangeAddProcess}
                                        margin="normal"
                                    />
                                </Col>
                            </Row>
                            <Row className="my-3">
                                <Col md={6}>
                                    <CustomTextField
                                        label="موقعیت بارنامه"
                                        name="cargo_location"
                                        value={addProcess.cargo_location}
                                        handleChange={handleChangeAddProcess}
                                        margin="normal"
                                    />
                                </Col>
                                <Col md={6}>
                                    <CustomPicker
                                        color="primary"
                                        value={addProcess.cargo_date}
                                        setValue={e =>
                                            setAddProcess({
                                                ...addProcess,
                                                cargo_date: new Date(e),
                                            })
                                        }
                                        label="تاریخ بارنامه"
                                    />
                                </Col>
                            </Row>
                            {createAddNewProcess()}
                            <Row className="my-3">
                                <Col className="text-center">
                                    <Button
                                        className="btn-bg-gold"
                                        onClick={addMoreProcessProduct}
                                    >
                                        ردیف جدید
                                    </Button>
                                </Col>
                            </Row>
                        </DialogContent>
                        <DialogActions>
                            <SubmitButton
                                variant="contained"
                                className="btn-bg-gold mx-2"
                                type="submit"
                                // loading={addOrderLoading}
                                title={
                                    type === 'addNewProcess'
                                        ? 'ایجاد'
                                        : 'ویرایش'
                                }
                            />
                            <Button
                                variant="contained"
                                onClick={() => closeModal()}
                            >
                                بازگشت
                            </Button>
                        </DialogActions>
                    </Form>
                </>
            )
            break
        case 'deleteProcess':
            template = (
                <>
                    <DialogTitle id="max-width-dialog-title">
                        حذف پردازش
                    </DialogTitle>
                    <DialogContent>
                        <div className="text-center">
                            <DeleteOutlined className="text-danger" />
                        </div>
                        <DialogContentText>
                            آیا از حذف این پردازش اطمینان دارید؟
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <SubmitButton
                            variant="contained"
                            className="bg-danger text-white mx-2"
                            onClick={() =>
                                dispatch(
                                    deleteAProcessAction(data?.id, closeModal)
                                )
                            }
                            loading={deleteLoading}
                            title="حذف"
                        />
                        <Button
                            variant="contained"
                            onClick={() => closeModal()}
                        >
                            بازگشت
                        </Button>
                    </DialogActions>
                </>
            )
            break
        case 'deleteOrder':
            template = (
                <>
                    <DialogTitle id="max-width-dialog-title">
                        حذف سفارش
                    </DialogTitle>
                    <DialogContent>
                        <div className="text-center">
                            <DeleteOutlined className="text-danger" />
                        </div>
                        <DialogContentText>
                            آیا از حذف این سفارش اطمینان دارید؟
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <SubmitButton
                            variant="contained"
                            className="bg-danger text-white mx-2"
                            onClick={() =>
                                dispatch(
                                    deleteAOrderByAdminAction(
                                        data?.id,
                                        closeModal,
                                        tableBody
                                    )
                                )
                            }
                            loading={deleteLoading}
                            title="حذف"
                        />
                        <Button
                            variant="contained"
                            onClick={() => closeModal()}
                        >
                            بازگشت
                        </Button>
                    </DialogActions>
                </>
            )
            break
        case 'deleteProduct':
            template = (
                <>
                    <DialogTitle id="max-width-dialog-title">
                        حذف محصول
                    </DialogTitle>
                    <DialogContent>
                        <div className="text-center">
                            <DeleteOutlined className="text-danger" />
                        </div>
                        <DialogContentText>
                            آیا از حذف این محصول اطمینان دارید؟
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <SubmitButton
                            variant="contained"
                            className="bg-danger text-white mx-2"
                            onClick={() =>
                                dispatch(
                                    deleteAProductByAdminAction(
                                        data?.id,
                                        closeModal,
                                        tableBody
                                    )
                                )
                            }
                            loading={deleteLoading}
                            title="حذف"
                        />
                        <Button
                            variant="contained"
                            onClick={() => closeModal()}
                        >
                            بازگشت
                        </Button>
                    </DialogActions>
                </>
            )
            break
        case 'addProduct':
        case 'editProduct':
            template = (
                <>
                    <Form
                        enableReinitialize
                        initialValues={addProduct}
                        onSubmit={
                            type === 'addProduct'
                                ? handleAddNewProduct
                                : handleEditProduct
                        }
                        // onSubmit={handleAddNewProduct}
                        // validationSchema={addProductSchema}
                    >
                        <DialogTitle id="max-width-dialog-title">
                            {type === 'addProduct'
                                ? 'ایجاد محصول'
                                : 'ویرایش محصول'}
                        </DialogTitle>

                        <DialogContent>
                            {role === 'admin' && (
                                <Row className="my-3 ">
                                    <Col md={4}>
                                        <CustomTextField
                                            label="نام "
                                            name="name"
                                            value={addProduct.name}
                                            handleChange={
                                                handleChangeAddProduct
                                            }
                                            margin="normal"
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <CustomTextField
                                            label="کد محصول "
                                            name="code"
                                            value={addProduct.code}
                                            handleChange={
                                                handleChangeAddProduct
                                            }
                                            margin="normal"
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <Typography
                                            className="my-3"
                                            component="p"
                                        >
                                            وضعیت محصول:
                                        </Typography>
                                        <Select
                                            style={{ width: '100%' }}
                                            labelId="demo-simple-select-label-user_type"
                                            id="demo-simple-select-user_type"
                                            value={addProduct?.status}
                                            onChange={e =>
                                                setAddProduct(prev => ({
                                                    ...prev,
                                                    status: e.target.value,
                                                }))
                                            }
                                        >
                                            {productStatus.map(item => (
                                                <MenuItem
                                                    key={item?.id}
                                                    value={item?.value}
                                                >
                                                    {item?.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Col>
                                    <Col md={4}>
                                        <Typography
                                            className="my-3"
                                            component="p"
                                        >
                                            نوع محصول:
                                        </Typography>
                                        <Select
                                            style={{ width: '100%' }}
                                            labelId="demo-simple-select-label-user_type"
                                            id="demo-simple-select-user_type"
                                            value={addProduct?.is_vip}
                                            onChange={e =>
                                                setAddProduct(prev => ({
                                                    ...prev,
                                                    is_vip: e.target.value,
                                                }))
                                            }
                                        >
                                            {productType.map(item => (
                                                <MenuItem
                                                    key={item?.id}
                                                    value={item?.value}
                                                >
                                                    {item?.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Col>
                                </Row>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <SubmitButton
                                variant="contained"
                                className="btn-bg-gold mx-2"
                                type="submit"
                                loading={crudLoading}
                                title={
                                    type === 'addProduct' ? 'ایجاد' : 'ویرایش'
                                }
                            />
                            <Button
                                variant="contained"
                                onClick={() => closeModal()}
                            >
                                بازگشت
                            </Button>
                        </DialogActions>
                    </Form>
                </>
            )
            break
        case 'deleteAnAnnouncement':
            template = (
                <>
                    <DialogTitle id="max-width-dialog-title">
                        حذف اعلان
                    </DialogTitle>
                    <DialogContent>
                        <div className="text-center">
                            <DeleteOutlined className="text-danger" />
                        </div>
                        <DialogContentText>
                            آیا از حذف این اعلان اطمینان دارید؟
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <SubmitButton
                            variant="contained"
                            className="bg-danger text-white mx-2"
                            onClick={() =>
                                dispatch(
                                    deleteAnnouncementByAdminAction(
                                        data?.id,
                                        closeModal
                                    )
                                )
                            }
                            loading={deleteLoading}
                            title="حذف"
                        />
                        <Button
                            variant="contained"
                            onClick={() => closeModal()}
                        >
                            بازگشت
                        </Button>
                    </DialogActions>
                </>
            )
            break
        case 'showBuyers':
            template = (
                <>
                    <div>
                        <DialogTitle id="max-width-dialog-title">
                            لیست خریداران محصول &nbsp;{data.name}
                        </DialogTitle>
                        <DialogContent>
                            <ProductBuyersList id={data.id} />
                        </DialogContent>
                        <DialogActions>
                            <Button
                                variant="contained"
                                onClick={() => closeModal()}
                            >
                                بازگشت
                            </Button>
                        </DialogActions>
                    </div>
                </>
            )
            break
        case 'manualProductAmount':
            template = (
                <>
                    <Form
                        enableReinitialize
                        initialValues={addProduct}
                        onSubmit={
                            type === 'manualProductAmount'
                                ? handleManualProductAmount
                                : null
                        }
                    >
                        <DialogTitle id="max-width-dialog-title">
                            تعدادمحصول را وارد کنید
                        </DialogTitle>
                        <DialogContent>
                            <input
                                type="number"
                                min={0}
                                placeholder="0"
                                onClick={e => e.target.select()}
                                onChange={event =>
                                    setManualProductValue(event.target.value)
                                }
                                className="bg-gray-200 border-0 text-center"
                                style={{
                                    outline: '0',
                                    margin: '20px',
                                    width: '100px',
                                    fontSize: 25,
                                }}
                            />
                        </DialogContent>
                        <DialogActions>
                            <SubmitButton
                                variant="contained"
                                className="btn-bg-gold mx-2"
                                type="submit"
                                loading={crudLoading}
                                title="ثبت"
                            />
                            <Button
                                variant="contained"
                                onClick={() => closeModal()}
                            >
                                بازگشت
                            </Button>
                        </DialogActions>
                    </Form>
                </>
            )
            break

        default:
            template = null
    }

    return (
        <Dialog
            open={show}
            onClose={!isOutCloseDisable && closeModal}
            fullWidth={fullWidth}
            aria-labelledby={`dialog${data?.title}`}
            aria-describedby={`dialog${data?.title}`}
            maxWidth={size}
            scroll={scroll || 'paper'}
            style={{ overflow: 'hidden' }}
            ref={modalRef}
        >
            <PerfectScrollbar>{template}</PerfectScrollbar>
        </Dialog>
    )
}

export default CustomModal
